import { createFileRoute } from '@tanstack/react-router';

import { PostmanPage } from '@/features/docs';

export const Route = createFileRoute('/_authed/docs/postman')({
  component: PostmanPage,
});
